import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/auth/Login';
import TopMenu from './components/menu/TopMenu';
import LeftMenu from './components/menu/LeftMenu';
import Dashboard from './components/dashboard/Dashboard';
import Company from './components/company/Company';
import Location from './components/location/Location';
import Fleet from './components/fleet/Fleet';
import Access from './components/access/Access';
import User from './components/user/User';
import Monitor from './components/monitor/Monitor';
import Report from './components/report/Report';
import Trips from './components/report/Trips';
import Logs from './components/logs/Logs';
import FleetLogs from './components/logs/FleetLogs';
import FleetStatus from './components/logs/FleetStatus';
import Eligibility from './components/stellantis/Eligibility';
import FetchFleet from './components/stellantis/FetchFleet';
import RemoveFleet from './components/stellantis/RemoveFleet';
import AddFleet from './components/stellantis/AddFleet';
import KinesisEnroll from './components/stellantis/KinesisEnroll';
import CompatibilityCheck from './components/stellantis/CompatibilityCheck';
import Alerts from './components/report/Alerts';
import AlertMaps from './components/report/AlertMaps';
import TollsMap from './components/report/TollsMap';
import Tolls from './components/report/Tolls';
import Ford from './components/ford/ford';
import LocationTax from './components/bcf/LocationTax.js';
import AgentSaleActivity from './components/bcf/AgentSaleActivity.js';
import AgentSaleActivityToll from './components/bcf/AgentSaleActivityToll.js';
import BCFReport from './components/bcf/BCFReport.js';
import StolenVehicle from './components/monitor/StolenVehicle.js';
import StolenVehMap from './components/monitor/StolenVehMap.js';
import Onboard from './components/vw/Onboard';
import Status from './components/vw/Status';
import Offboard from './components/vw/OffBoard';
import RidesiqDevices from './components/ridesiq/RidesiqDevices';
import TollsReport from './components/bcf/TollsReport.js';
import VinMovement from './components/monitor/VinMovement.js';
import UpdateIMEI from './components/ridesiq/UpdateIMEI';
import MergedReport from './components/bcf/MergedReport.js';
import StellantisCheck from './components/stellantis/StellantisCheck.js';
import FetchNissanFleet from './components/nissan/FetchFleet.js';

function App() {
  const [loginSuccess, setLoginSuccess] = useState(false)
  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("tm_token");
    if (loggedInUser) {
      setLoginSuccess(true);
    }
  },[])
  return (
    <>
      <Router>
        {loginSuccess && !window.location.pathname.includes("/alert_maps") && !window.location.pathname.includes("/toll_maps")?
        <>
          <TopMenu />
          <LeftMenu />
        </>:""
        }
        <Routes>
          {!loginSuccess?
            <Route exact path="/" element={<Login setLoginSuccess={setLoginSuccess} />} />
            :
            (<>
              <Route exact path="/" element={<Dashboard />} />
              <Route exact path="/company" element={<Company />} />
              <Route exact path="/location" element={<Location />} />
              <Route exact path="/fleet" element={<Fleet />} />
              <Route exact path="/access" element={<Access />} />
              <Route exact path="/user" element={<User />} />
              <Route exact path="/monitor" element={<Monitor />} />
              <Route exact path="/r_dashboard" element={<Report />} />
              <Route exact path="/r_trips" element={<Trips />} />
              <Route exact path="/r_alerts" target="_blank" element={<Alerts />} />
              <Route exact path="/r_tolls" target="_blank" element={<Tolls />} />
              {/* <Route exact path="/logs" element={<Logs />} /> */}
              <Route exact path="/fleet_logs" element={<FleetLogs />} />
              <Route exact path="/fleet_status" element={<FleetStatus />} />
              <Route exact path="/s_eligibility" element={<Eligibility />} />
              <Route exact path="/s_fetch" element={<FetchFleet />} />
              <Route exact path="/s_removefleet" element={<RemoveFleet />} />
              <Route exact path="/s_addfleet" element={<AddFleet />} />
              <Route exact path="/kinesis_enroll" element={<KinesisEnroll />} />
              <Route exact path="/compatibility_check" element={<CompatibilityCheck />} /> 
              <Route exact path="/alert_maps" element={<AlertMaps />} />
              <Route exact path="/toll_maps" element={<TollsMap />} />
              <Route exact path="/ford" element={<Ford />} />
              <Route exact path="/location_tax" element={<LocationTax />} />
              <Route exact path="/asa_upload" element={<AgentSaleActivity />} />
              <Route exact path="/asat_upload" element={<AgentSaleActivityToll />} />
              <Route exact path="/bcf_report" element={<BCFReport />} />
              <Route exact path="/stolen_vehicle" element={<StolenVehicle />} />
              <Route exact path='/stolen_vehicle_map' element={<StolenVehMap />}/>
              <Route exact path="/vw_onboard" element={<Onboard />} />
              <Route exact path="/vw_status" element={<Status />} />
              <Route exact path="/vw_offboard" element={<Offboard />} />
              <Route exact path="/ridesiq_devices" element={<RidesiqDevices />} />
              <Route exact path="/tolls_report" element={<TollsReport />} />
              <Route exact path="/vin_movement" element={<VinMovement />} />
              <Route exact path="/update_imei" element={<UpdateIMEI />} />
              <Route exact path="/merged_report" element={<MergedReport />} />
              <Route exact path="/stellantis_check" element={<StellantisCheck />} />
              <Route exact path="/n_fetch" element={<FetchNissanFleet />} />
            </>)
          }
        </Routes>
      </Router>
    </>
  );
}

export default App;
